'use client';

const sizeValues = {
  sm: 16,
  md: 24,
  lg: 32
};
export {
  sizeValues
};
